module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.template === 'edit' || typeof _vm.template === 'undefined') ? [_c('label', {
    class: _vm.labelClass ? _vm.labelClass : 'u-label'
  }, [_vm._v("\n      " + _vm._s(_vm.field.label + (_vm.field.required ? '* ' : '')) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "c-percent-field"
  }, [(!_vm.field.readonly) ? _c('input', {
    ref: "input",
    class: 'qa-' + _vm.field.name + '__input',
    attrs: {
      "type": "number",
      "placeholder": "0.00"
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": function($event) {
        return _vm.update($event.target)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.field.readonly) ? _c('input', {
    class: 'qa-' + _vm.field.name + '__input',
    attrs: {
      "type": "number",
      "placeholder": "0.00",
      "readonly": "readonly",
      "disabled": "disabled"
    },
    domProps: {
      "value": _vm.value
    }
  }) : _vm._e(), _vm._v(" "), _vm._m(0)])] : _vm._e(), _vm._v(" "), (_vm.template === 'detail') ? [_c('label', {
    class: _vm.labelClass ? _vm.labelClass : 'u-label'
  }, [_vm._v("\n      " + _vm._s(_vm.field.label + (_vm.field.required ? '* ' : '')) + "\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "u-paragraph",
    class: 'qa-' + _vm.field.name + '__value'
  }, [_vm._v("\n      " + _vm._s(_vm.formattedNumber(_vm.value)) + "\n    ")])] : _vm._e()], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-percent-field__percent-icon"
  }, [_c('i', {
    staticClass: "fa fa-percent"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-69858478"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/fields/FieldPercent.vue
// module id = 547
// module chunks = 1